import { useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import { NAV_LINKS, WHATSAPP_URL } from "@/constants/links";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="fixed inset-x-0 top-0 z-50 bg-ujn-deep border-b border-ujn-accent/25"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 sm:h-[72px] lg:px-8">
        <a href="#home" data-testid="nav-logo" className="flex items-center gap-3" onClick={() => setOpen(false)}>
          <img src="/ujn-mark.svg" alt="PT Utama Jaya Nitya logo" className="h-9 w-9" />
          <span className="hidden flex-col leading-tight sm:flex">
            <span className="font-heading text-[13px] font-bold tracking-[0.18em] text-ujn-offwhite">
              PT UTAMA JAYA NITYA
            </span>
            <span className="font-mono text-[10px] tracking-[0.22em] text-ujn-subtle">
              BULK LIQUID STORAGE &amp; HANDLING
            </span>
          </span>
        </a>

        <nav data-testid="desktop-nav" className="hidden items-center gap-7 lg:flex">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={link.testId}
              className="font-mono text-[11px] tracking-[0.18em] text-ujn-offwhite/75 transition-colors duration-200 hover:text-ujn-offwhite"
            >
              {link.label}
            </a>
          ))}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-button"
            className="ml-2 inline-flex items-center gap-2 border border-ujn-subtle bg-ujn-medium px-4 py-2 font-mono text-[11px] tracking-[0.16em] text-ujn-offwhite transition-colors duration-200 hover:bg-ujn-accent"
          >
            <MessageCircle className="h-3.5 w-3.5" />
            WHATSAPP
          </a>
        </nav>

        <button
          type="button"
          aria-label="Open menu"
          data-testid="mobile-menu-button"
          onClick={() => setOpen(!open)}
          className="flex h-10 w-10 items-center justify-center border border-ujn-accent/40 text-ujn-offwhite lg:hidden"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="border-t border-ujn-accent/25 bg-ujn-deep lg:hidden">
          <nav className="mx-auto flex max-w-7xl flex-col px-5 py-4">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`mobile-${link.testId}`}
                onClick={() => setOpen(false)}
                className="border-b border-ujn-accent/15 py-3.5 font-mono text-xs tracking-[0.2em] text-ujn-offwhite/85 transition-colors duration-200 hover:text-ujn-offwhite"
              >
                {link.label}
              </a>
            ))}
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-nav-whatsapp-button"
              className="mt-4 mb-2 inline-flex items-center justify-center gap-2 border border-ujn-subtle bg-ujn-medium px-4 py-3 font-mono text-xs tracking-[0.18em] text-ujn-offwhite"
            >
              <MessageCircle className="h-4 w-4" />
              WHATSAPP
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;
